import React from "react";
import ProductsSearch from "@admin/components/ProductsSearch";

export default function ReplacementSku({
    replacementSku,
    replacementProductTitle,
}: {
    replacementSku: string | null;
    replacementProductTitle: string | null;
}) {
    return (
        <div className="rounded border p-10 mb-5">
            <h4 className="mb-5">Артикул на подмену</h4>

            <ProductsSearch
                inputName="additional_product_attributes[replacement_sku]"
                productId={replacementSku}
                productTitle={replacementProductTitle ?? replacementSku}
            />
        </div>
    );
}
